export default function topHeader() {
  return (
    <header className=" bg-black p-2 font-thin text-white text-center">
      <span className="">Use promo code </span>
      <span className="mr-1 font-bold">
        <a href="https://www.linkedin.com/in/moemenadam/" target="_blank">Moemen</a>
      </span>
      <span>for 20% discount</span>
    </header>
  )
}
